/**
 * Resolve the signed-in user to a jobsStaff id.
 * Used for the intake form's default assignee and the header "my jobs" badges.
 * Keep in sync with resolveStaffIdForUser() in backend/routes/jobs.js.
 */

/**
 * @param {Array<{ id: string, name?: string, email?: string }>} staff
 * @param {{ email?: string, displayName?: string } | null | undefined} currentUser
 * @returns {string} staff id, or 'unassigned' when no match
 */
export function resolveSelfStaffId(staff, currentUser) {
  if (!currentUser || !Array.isArray(staff) || staff.length === 0) return 'unassigned';

  const byEmail = staff.find(s => s.email && s.email === currentUser.email);
  if (byEmail) return byEmail.id;

  const byName = staff.find(s =>
    s.name && currentUser.displayName && s.name.toLowerCase() === currentUser.displayName.toLowerCase());
  if (byName) return byName.id;

  // Display names often carry a surname/initial ("Rhys E") while staff records are
  // first-name only ("Rhys"). Match on the first token so those users still resolve.
  const firstName = currentUser.displayName?.trim().split(/\s+/)[0]?.toLowerCase();
  const byFirstName = firstName && staff.find(s =>
    s.id === firstName || (s.name && s.name.toLowerCase() === firstName));
  if (byFirstName) return byFirstName.id;

  const emailPrefix = currentUser.email?.split('@')[0]?.toLowerCase();
  const byEmailPrefix = emailPrefix && staff.find(s =>
    s.id === emailPrefix || (s.email && s.email.split('@')[0]?.toLowerCase() === emailPrefix));
  if (byEmailPrefix) return byEmailPrefix.id;

  return 'unassigned';
}
